<!-- 表单的筛选 -->
<template>
    <div>
        <el-tag :type="tagclass">{{tagtext}}</el-tag>
    </div>    
</template>

<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "StatusTag",
  
  mixins: [BaseVue],
  
  props: {
    status: {
      type: Number,
      default: 0
    }
  },
  
  data() {
    return {
      tagclass: "info",
      tagtext: ""
    };
  },
  
  methods: {
    init() {
      if (this.status == 1) {
        this.tagclass = "success";
        this.tagtext = "审核通过";
      } else if (this.status == 2) {
        this.tagclass = "warning";
        this.tagtext = "审核失败";
      } else if (this.status == 0) {
        this.tagclass = "info";
        this.tagtext = "等待审核";
      } else {
        this.tagclass = "info";
        this.tagtext = "未定义";
      }
    },
    
    change() {
      // 改变状态的逻辑
    },
    
    clear() {
      // 清除状态的逻辑
    }
  },
  
  mounted() {
    this.init();
  },
  
  watch: {
    status: {
      handler() {
        this.init();
      },
      immediate: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
